function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#5E5E5E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2.308 0C1.043 0 0 1.13 0 2.5v25C0 28.87 1.043 30 2.308 30h15.384C18.957 30 20 28.87 20 27.5V8.333c.002-.224-.08-.44-.228-.599l-6.923-7.5c-.145-.151-.34-.236-.541-.234h-10zm0 1.667h9.23v6.666c0 .46.345.834.77.834h6.153V27.5c0 .476-.33.833-.769.833H2.308c-.44 0-.77-.357-.77-.833v-25c0-.476.33-.833.77-.833zm10.769 1.172L17.38 7.5h-4.303V2.839z",
  transform: "translate(-39 -578) translate(39 578)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 13c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zM4.73 13.001c-.273.017-.519.223-.645.54-.125.318-.112.698.036 1 .148.3.408.475.681.458h8.422c.276.005.532-.184.672-.495.139-.312.139-.696 0-1.008-.14-.31-.396-.5-.672-.495H4.73zM16 18c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zM4.73 18.001c-.273.017-.519.223-.645.54-.125.318-.112.698.036 1 .148.3.408.475.681.458h8.422c.276.005.532-.184.672-.495.139-.312.139-.696 0-1.008-.14-.31-.396-.5-.672-.495H4.73zM16 23c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zM4.73 23.001c-.273.017-.519.223-.645.54-.125.318-.112.698.036 1 .148.3.408.475.681.458h8.422c.276.005.532-.184.672-.495.139-.312.139-.696 0-1.008-.14-.31-.396-.5-.672-.495H4.73z",
  transform: "translate(-39 -578) translate(39 578)"
}))));

function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.f0f9a5be.svg";
export { ForwardRef as ReactComponent };